import * as React from 'react';
import {
    Card,
    CardContent,
    BlockTitle
} from 'framework7-react';
import './eventInfoCard.css'
import { withTranslation } from 'react-i18next';

import {formateTimestamp} from '../../../../functions';

class EicSmall extends React.Component {
    render() {
        const { t } = this.props;
        return <>
                <BlockTitle>{t('more_info')}</BlockTitle>
                <Card className="event-info-card">
                <CardContent>
                    <p dangerouslySetInnerHTML={
                        {__html: t('event.available_for_registration_periode',{start_date:formateTimestamp(this.props.data.singup_periode.start),end_date:formateTimestamp(this.props.data.singup_periode.end)})}
                    }
                    />
                    {this.props.data.options.allow_cancel > 0 &&
                    <p>
                        {t('event.available_for_cancelation')}
                        &nbsp;
                        {this.props.data.options.cancel_time > 0 &&
                        t('event.cancelation_deadline',{date_time:formateTimestamp(this.props.data.options.cancel_time)})
                        }
                    </p>
                    }
                </CardContent>
            </Card>
        </>;
    }
};
export default withTranslation()(EicSmall);